import { useEffect } from 'react'
import Button from '@dustin-web/microsite-components/src/button'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import CartHeader from '../cart-header'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'

export const EmptyCart = () => {
  const { translate } = useTranslations()

  useEffect(() => {
    DigitalData.pushSimpleEvent('view_empty_cart')
  }, [])

  return (
    <>
      <div className="u-pt-24 u-pt-md-96">
        <CartHeader />
        <Button primary link href="/" text={translate('Homepage')} icon="arrow-left" leftIcon />
      </div>
    </>
  )
}
